<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="通话统计">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con search-condition-first show">

                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" :clueId=1 :init-choose-first="true" :dataType=1  @created="handleSearch"></site-auto-complete>
                            </div>
                        </div>

                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="checkDate('month')" :class="condition.timeStamp === 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="checkDate('doubleMonth')" :class="condition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="condition.time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="condition.timeStamp = ''"
                                    >
                                </el-date-picker>
                            </div>
                            <el-button type="primary" @click="handleSearch()" class="phone-analysis-btn">搜索</el-button>
                        </div>
                    </div>
                    <div class="customTab" v-loading="isLoading">
                        <div class="tabBox">
                            <div class="item_tab " :class="type==0?'active':''" @click="chooiceTab(0)">
                                <div class="item_value">{{call_num}}</div>
                                <div class="item_text">通话数量</div>
                            </div>
                            <div class="item_tab" :class="type==1?'active':''" @click="chooiceTab(1)">
                                <div class="item_value">{{completion_num}}</div>
                                <div class="item_text">接通数量</div>
                            </div>
                            <div class="item_tab" :class="type==2?'active':''" @click="chooiceTab(2)">
                                <div class="item_value">{{completion_rate}}%</div>
                                <div class="item_text">接通率</div>
                            </div>
                            <div class="item_tab" :class="type==3?'active':''" @click="chooiceTab(3)">
                                <div class="item_value">{{bill_duration}}分</div>
                                <div class="item_text">通话时长</div>
                            </div>
                            <div class="item_tab" :class="type==3?'active':''" @click="chooiceTab(3)">
                                <div class="item_value">{{payable_amount_yuan}}元</div>
                                <div class="item_text">通话费用</div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                >
                    <el-table-column  label="时间" prop="date"></el-table-column>
                    <el-table-column  label="通话数量" prop="call_num"></el-table-column>
                    <el-table-column  label="接通数量" prop="completion_num"></el-table-column>
                    <el-table-column  label="通话时长(分)" prop="bill_duration"></el-table-column>
                    <el-table-column  label="接通率" prop="completion_rate"></el-table-column>
                    <el-table-column  label="通话费用(元)" prop="payable_amount_yuan"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import {getSite} from '@/service/site'
    import {getUser} from '@/utils/auth'
    import {getSiteReport} from '@/service/hotline'
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
export default {
    name: 'DataPhoneAnalysis',
    components: {SiteAutoComplete},
    data () {
        return {
            list: [],
            condition: {
                site_id: '',
                time: '',
                timeStamp: 'month',
            },
            bill_duration: 0,
            call_num: 0,
            completion_num: 0,
            completion_rate: 0,
            payable_amount: 0,
            payable_amount_yuan: 0,
            loading: false,
            options: [],
            isLoading: false,
            type: 0
        }
    },
    mounted (){
        this.isLoading = true
    },
    methods: {
        chooiceTab(){

        },
        checkDate (value) {
            this.condition = Object.assign({}, this.condition, {
                timeStamp: value,
                time: ''
            })
        },
        handleSearch(){
            this.list = []
            this.bill_duration = 0
            this.call_num = 0
            this.completion_num = 0
            this.payable_amount = 0
            this.payable_amount_yuan = 0
            this.completion_rate = 0
            if (!!this.condition.site_id === false) {
                this.isLoading = false
                this.$message({
                    message: '请选择站点',
                    type: 'error',
                    duration: 3 * 1000
                })
                return
            }
            let query = {
                site_id : this.condition.site_id,
            }
            if (this.condition.timeStamp.length > 0) {
                let time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                query.start_time = Date.parse(new Date())/1000 - 30 * 24 * 3600
                query.end_time = Date.parse(new Date())/1000
            } else if(this.condition.time && this.condition.time.length > 0) {
                query.start_time = Date.parse(new Date(this.condition.time[0]))/1000
                query.end_time = Date.parse(new Date(this.condition.time[1]))/1000
            } else {
                this.$message({
                    message: '请选择时间段',
                    type: 'error',
                    duration: 3 * 1000
                })
                return
            }
            this.isLoading = true
            // 模拟fetch请求数据....
            getSiteReport(query).then((data) => {
                if (data.day_detail) {
                    for (let i in data.day_detail) {
                        let row = data.day_detail[i]
                        row.completion_rate = (row.completion_rate * 100).toString() + '%'
                        row.date = i
                        this.list.push(row)
                    }
                }
                if (data.total) {
                    this.bill_duration = data.total.bill_duration
                    this.call_num = data.total.call_num
                    this.completion_num = data.total.completion_num
                    this.payable_amount = data.total.payable_amount
                    this.payable_amount_yuan = data.total.payable_amount_yuan
                    this.completion_rate = data.total.completion_rate * 100
                }
                this.isLoading = false
            })
        },
    }
}
</script>
<style scoped>
.phone-analysis-btn{
    line-height: 36px;
    height: 36px;
    padding: 0 20px;
    margin-left: 10px;
}
</style>
